export default __webpack_public_path__ + "img/a6457d295556b3b9c811aae7b1b0040c.png";